import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { accessTrackRoutes } from './features/access-track/access-track.route';
import { ascRoutes } from './features/asc/asc.route';
import { authRoutes } from './features/auth/auth.route';
import { coraRoutes } from './features/cora/cora.route';
import { coraMapRoute } from './features/cora/pages/public-map/public-map.route';
import { creditRoutes } from './features/credit/credit.route';
import { extractionRoutes } from './features/extraction/extraction.routes';
import { parametresRoutes } from './features/parametres/parametres.route';
import { powerBiRoutes } from './features/power-bi/power-bi.route';
import { MainLayout } from './shared/layouts/main-layout/main-layout.component';
import { currentUserResolver } from './shared/layouts/main-layout/main-layout.resolver';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
  coraMapRoute,
  authRoutes,
  {
    path: 'app',
    children: [
      {
        path: '',
        canActivateChild: [authGuard],
        resolve: { currentUser: currentUserResolver },
        component: MainLayout,
        children: [
          {
            path: 'home',
            loadComponent: () =>
              import('./features/home/home.component').then((m) => m.Home),
          },
          powerBiRoutes,
          coraRoutes,
          ascRoutes,
          creditRoutes,
          parametresRoutes,
          accessTrackRoutes,
          ...extractionRoutes,
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'home',
          },
        ],
      },
    ],
  },
  {
    path: 'ui',
    loadComponent: () =>
      import('./features/ui/ui.component').then((m) => m.UiComponent),
  },
  // {
  //   path: 'ui/planification',
  //   loadComponent: () =>
  //     import('./features/ui/planification-action/planification-action.component').then(
  //       (m) => m.PlanificationActionComponent,
  //     ),
  // },
  {
    path: '**',
    redirectTo: 'app/home',
  },
];
